/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRectangleCloud = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 4a2 2 0 0 1 2 2h2a2 2 0 1 1 4 0h2a2 2 0 1 1 2 2v2a2 2 0 1 1 0 4v2a2 2 0 1 1-2 2h-2a2 2 0 1 1-4 0H8a2 2 0 1 1-2-2v-2a2 2 0 1 1 0-4V8a2 2 0 1 1 0-4zm3-.646A4 4 0 1 0 3.354 9C2.524 9.733 2 10.805 2 12s.524 2.267 1.354 3A4 4 0 1 0 9 20.646c.733.83 1.805 1.354 3 1.354s2.267-.524 3-1.354A4 4 0 1 0 20.646 15c.83-.733 1.354-1.805 1.354-3s-.524-2.267-1.354-3A4 4 0 1 0 15 3.354C14.267 2.524 13.195 2 12 2s-2.267.524-3 1.354z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRectangleCloud as RectangleCloud };
